export const AppConstant = {
    defaultAppBackgroundColor: "#f0f2f8",
    secureStorgaeKeys: {
        password: "passKey",
    },
};
